import { render, staticRenderFns } from "./ClientLogo.vue?vue&type=template&id=170a3012&"
import script from "./ClientLogo.vue?vue&type=script&lang=js&"
export * from "./ClientLogo.vue?vue&type=script&lang=js&"
import style0 from "./ClientLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports